import styled from "styled-components";

import * as styles from "styles";
// import * as Types from "Types";

const Wrap = styled.div<any>`
   ${styles.Typography.description1}
   ${({ css }) => css}
`;

export default function Description1(props: any) {
   return <Wrap {...props}>{props.children}</Wrap>;
}
